import classnames from 'classnames';
import React, { useRef } from 'react';
import { getUpdatedTextWithEmoji } from '../EmojiPicker/emoji-picker-helpers';
import { EmojiPicker } from '../EmojiPicker/EmojiPicker';
import TextInput, { TextInputProps } from '../TextInput';
import './InputWithEmoji.pcss';

type OuterProps = {
  onChange: (text: string) => void;
  className?: string;
  emojiPickerClassName?: string;
  textInputClassName?: string;
  inputRef?: React.MutableRefObject<
    HTMLTextAreaElement | HTMLInputElement | undefined
  >;
};

type Props = OuterProps & Omit<TextInputProps, 'onChange' | 'inputRef'>;

export const InputWithEmoji = (props: Props) => {
  const {
    className,
    onChange,
    value,
    emojiPickerClassName,
    textInputClassName,
    disabled,
    inputRef: outerInputRef,
    ...textInputProps
  } = props;
  const inputRef = useRef<HTMLTextAreaElement | HTMLInputElement>();

  const insertEmoji = (emoji: string) => {
    const newText = getUpdatedTextWithEmoji(
      value || '',
      emoji,
      inputRef.current,
      true,
    );
    onChange(newText);
  };

  return (
    <div className={classnames('input-with-emoji', className)}>
      <TextInput
        {...textInputProps}
        value={value}
        inputRef={r => {
          inputRef.current = r;
          if (outerInputRef) {
            outerInputRef.current = r;
          }
        }}
        onChange={e => onChange(e.target.value)}
        className={textInputClassName}
        disabled={disabled}
      />

      <EmojiPicker
        onEmojiPicked={insertEmoji}
        className={classnames(
          'input-with-emoji__emoj-picker',
          emojiPickerClassName,
          { 'input-with-emoji__emoj-picker--disabled': disabled },
        )}
      />
    </div>
  );
};
